/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
export const JWT_ACCESS_TOKEN_KEY = 'mc_jwt_access_token';
export const JWT_REFRESH_TOKEN_KEY = 'mc_jwt_refresh_token';

export default class LocalStorageService {
	setTokens(access_token, refresh_token) {
		if (access_token) localStorage.setItem(JWT_ACCESS_TOKEN_KEY, access_token);
		if (refresh_token) localStorage.setItem(JWT_REFRESH_TOKEN_KEY, refresh_token);
	}

	getAccessToken() {
		return localStorage.getItem(JWT_ACCESS_TOKEN_KEY);
	}

	getRefreshToken() {
		return localStorage.getItem(JWT_REFRESH_TOKEN_KEY);
	}

	clearTokens() {
		localStorage.removeItem(JWT_ACCESS_TOKEN_KEY);
		localStorage.removeItem(JWT_REFRESH_TOKEN_KEY);
	}
}
